export default {
  data () {
    return {
      title: 'Công ty cổ phần Timebird'
    }
  },
  computed: {
  },
  methods: {
    setTitle: function () {
      if (this.$route && this.$route.meta && this.$route.meta.title) {
        document.title = '' + this.$route.meta.title + ' | ' + this.title
      } else {
        document.title = this.title
      }
    }
  },
  created() {
    this.setTitle()
  },
  watch: {
    '$route' () {
      this.setTitle()
    }
  }
}
